import { render, staticRenderFns } from "./api-env-switch.vue?vue&type=template&id=042b64fd&scoped=true&"
import script from "./api-env-switch.vue?vue&type=script&lang=js&"
export * from "./api-env-switch.vue?vue&type=script&lang=js&"
import style0 from "./api-env-switch.vue?vue&type=style&index=0&id=042b64fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042b64fd",
  null
  
)

export default component.exports